import { c as _c } from "react/compiler-runtime";
import { SomniaLogoCircle } from "./SomniaLogoCircle";
export const SomniaLogoSquare = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <SomniaLogoCircle square={true} {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};